import {Check} from "@sparkware/app-utils";
import {observer} from "mobx-react";
import {useServices} from "../../../../../../react-hooks/use-services.hook";
import {GameInfo} from "../../../../../../services/games/game-info";
import {TableSeatsComponent} from "../../../../../arena-host/new-live-casino-arena/live-casino-arena-grid/shared-components/table-seats.component";
import {GameJackpotComponent} from "../../../../../game-jackpot/game-jackpot.component";
import {VideoListJackpotContainerBox} from "../../../../../live-streaming-tile/static-video-specific-components/video-list-jackpot-container/video-list-jackpot-container.box";
import {VideoListJackpotValueBox} from "../../../../../live-streaming-tile/static-video-specific-components/video-list-jackpot-value/video-list-jackpot-value.box";
import {VideoTileBettingRangeBox} from "../../../../../live-streaming-tile/video-common-components/video-tile-betting-range/video-tile-betting-range.box";
import {LiveStreamSlideFooterDefaultBox} from "./boxes/live-stream-slide-footer/live-stream-slide-footer.box";
import {LiveStreamSlideGameDetailsBox} from "./boxes/live-stream-slide-game-details/live-stream-slide-game-details.box";

export type LiveStreamVideoSlideFooterType = "jackpot" | "bets";

interface LiveStreamSlideFooterProps {
    gameInfo: GameInfo;
    type: LiveStreamVideoSlideFooterType;
}
export const LiveStreamSlideFooterComponent: React.FC<LiveStreamSlideFooterProps> = observer((props) => {
    const services = useServices();
    const tableInfo = services.liveTableFeeds.getTableInfo(props.gameInfo.gameType);


    const _renderSecondaryText = () => {
        switch (props.type) {
            case "bets":
                return _renderMinMaxBet();
            case "jackpot":
                return _renderJackpot();
            default:
                return null;
        }
    }


    const _renderMinMaxBet = () => {
        let minBet: number;
        let maxBet: number;

        if (Check.isNullOrUndefined(tableInfo?.MinBet) || Check.isNullOrUndefined(tableInfo?.MaxBet)) {
            minBet = props.gameInfo.minBet;
            maxBet = props.gameInfo.maxBet;
        } else {
            minBet = tableInfo.MinBet;
            maxBet = tableInfo.MaxBet;
        }

        return (
            <VideoTileBettingRangeBox>
                {services.currency.formatMinMaxBet(minBet, maxBet)}
            </VideoTileBettingRangeBox>
        );
    }

    const _renderJackpot = () => {
        if (!props.gameInfo.hasJackpot) {
            return null;
        }

        return (
            <VideoListJackpotContainerBox>
                <span>
                    {services.translation.translate("JACKPOT")}
                </span>
                <VideoListJackpotValueBox>
                    <GameJackpotComponent gameType={props.gameInfo.gameType} />
                </VideoListJackpotValueBox>
            </VideoListJackpotContainerBox>
        );
    }

    return (
        <LiveStreamSlideFooterDefaultBox>
            <LiveStreamSlideGameDetailsBox>
                {_renderSecondaryText()}
                <TableSeatsComponent isLiveStreamOverlay tableInfo={tableInfo}/>
            </LiveStreamSlideGameDetailsBox>
        </LiveStreamSlideFooterDefaultBox>)
})